import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Routes, Route } from "react-router";

import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import ChatBot from './pages/ChatBot';
import ListVault from './pages/ListVault';
import About from './pages/About';
import QrScanner from './pages/QrScanner';
import reportWebVitals from './reportWebVitals';

import appAjax from './helpers/ajax';

import { firebaseConfig } from './helpers/firebase';

appAjax.apiBaseUrl = process.env.REACT_APP_PUBLIC_API_BASE;
appAjax.wsBaseUrl = process.env.REACT_APP_PUBLIC_WS_BASE;
appAjax.utilBaseUrl = process.env.REACT_APP_PUBLIC_UTIL_BASE;

//this function will be called when JsQRScanner is ready to use
window.JsQRScannerReady = function()
{
    appAjax.JsQRScanner = window.JsQRScanner;
    //console.log("JsQRScanner Ready");
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js').then(registration => {
    const target = registration.active || registration.waiting || registration.installing;
    target?.postMessage({
      type: 'INIT_FIREBASE',
      config: firebaseConfig,
    });
  }).catch(error => console.log('Service Worker registration failed:', error));
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route index element={<App />} />
        <Route path="/chat" element={<ChatBot />} />
        <Route path="/vaults" element={<ListVault />} />
        <Route path="/scanner" element={<QrScanner />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </HashRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
